import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ModelVariableNodeView from "./ModelQuantityNodeView";

const ModelQuantity = Node.create({
    name: "modelVariable",
    group: "inline",
    // inline: true,
    selectable: true,
    atom: true,

    inline() {
        return true;
    },

    addAttributes() {
        return {
            "model-variable-id": { default: null },
            "time-horizon-id": { default: null },
            "model-variable-name": { default: null },
            "time-index": { default: null },
            "rich-text-model-quantity-id": { default: null },
            // Opt-in per quantity: when true, the value span gets a
            // data-sign attribute (positive/negative) so CSS can color it.
            "color-by-sign": { default: false },
            // Trailing label tagged with the value (e.g. "YoY", "YtD").
            // Rendered inside the value's styled span so it inherits coloring.
            suffix: { default: null },
            // Opt-in per quantity: replace the value's leading +/- sign with a
            // designer-chosen glyph (e.g. ▲/▼). Zero stays neutral. The glyph
            // characters default to up/down triangles but are editable.
            "use-sign-glyph": { default: false },
            "positive-glyph": { default: "▲" },
            "negative-glyph": { default: "▼" },
        };
    },

    parseHTML() {
        return [
            {
                tag: "span[data-rich-text-model-quantity-id]",
                getAttrs: (el) => {
                    if (typeof el === "string") return {};
                    const element = el as HTMLElement;
                    return {
                        "rich-text-model-quantity-id": element.getAttribute(
                            "data-rich-text-model-quantity-id",
                        ),
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const attrs = mergeAttributes(HTMLAttributes);
        return ["span", attrs, ""];
    },
     
    selectNode() {
        this.dom.classList.add("ProseMirror-selectednode");
    },

    deselectNode() {
        this.dom.classList.remove("ProseMirror-selectednode");
    },
});

export const ModelVariableWithView = ModelQuantity.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ModelVariableNodeView);
    },
});
